// Auto-capitalization for live voice-typing dictation. Chrome's
// SpeechRecognition never capitalizes or punctuates on its own, so every
// finalized transcript chunk lands lowercase unless we fix it up here.
//
// Only capitalizes — deliberately does NOT auto-insert periods. Chrome
// finalizes a chunk on any pause (not necessarily a real sentence end), so
// auto-adding a period per chunk would plant stray periods whenever the
// user pauses mid-sentence to think.

const SENTENCE_END_RE = /[.!?\n]$/;
// Strip only horizontal whitespace so a trailing newline (paragraph break)
// still counts as a sentence boundary below.
const TRAILING_HSPACE_RE = /[ \t]+$/;

/**
 * Capitalizes the first letter of a finalized dictation chunk if it lands
 * at the start of a sentence — start of document, or right after a
 * . ! ? or a line break already in the note.
 *
 * @param {import('quill').default} quill - the live Quill instance
 * @param {number} cursorPosition - insertion point, before this text lands
 * @param {string} transcriptText - the finalized chunk about to be inserted
 * @returns {string} transcriptText, capitalized if it starts a sentence
 */
export function capitalizeDictatedSegment(quill, cursorPosition, transcriptText) {
  if (!transcriptText) return transcriptText;
  try {
    const start = Math.max(0, cursorPosition - 60);
    const lookback = quill.getText(start, cursorPosition - start).replace(TRAILING_HSPACE_RE, '');
    const atSentenceStart = lookback === '' || SENTENCE_END_RE.test(lookback);
    if (!atSentenceStart) return transcriptText;
    return transcriptText.replace(/^(\s*)([a-z])/, (_m, ws, ch) => ws + ch.toUpperCase());
  } catch (_) {
    return transcriptText;
  }
}
